import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// styles
import styles from './PdpSharedMakerHeadshotModule.scss';

// helpers
import get from 'lodash.get';

function PdpSharedMakerHeadshotModuleComponent({ seller, renderHeadshot }) {
    const name = get(seller, 'sellerProfile.company');
    const urlLabel = get(seller, 'sellerPreferences.urlLabel');

    const liveStorefront = get(seller, 'liveStorefrontProfile') || {};
    const photos = get(liveStorefront, 'photos') || [];
    const headshot = photos.find(photo => get(photo, 'type.name') === 'DEALER_STOREFRONT_HEADSHOT');

    return (
        <div className={styles.wrapper}>
            {/* Headshot */}
            {!!(headshot && headshot.path) && (
                <div className={styles.imageWrap}>
                    {renderHeadshot({ path: headshot.path, imgClass: styles.image, alt: name })}
                </div>
            )}
            {/* View Profile link */}
            <a href={`/dealers/${urlLabel}/`} className={styles.name}>
                {name}
            </a>
        </div>
    );
}

PdpSharedMakerHeadshotModuleComponent.propTypes = {
    seller: PropTypes.object.isRequired,
    renderHeadshot: PropTypes.func.isRequired,
};

PdpSharedMakerHeadshotModuleComponent.defaultProps = {
    //eslint-disable-next-line react/prop-types
    renderHeadshot: ({ path, imgClass, alt }) => <img className={imgClass} src={path} alt={alt} />,
};

export const PdpSharedMakerHeadshotModule = createFragmentContainer(
    PdpSharedMakerHeadshotModuleComponent,
    {
        seller: graphql`
            fragment PdpSharedMakerHeadshotModule_seller on Seller {
                sellerProfile {
                    company
                }
                sellerPreferences {
                    urlLabel
                }
                liveStorefrontProfile {
                    photos {
                        type {
                            name
                        }
                        path
                    }
                }
            }
        `,
    }
);
